import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../material.module';
import { SettingsService } from '@lib/services/settings/settings.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';
import { AdminProfileModalComponent } from '../admin-profile-modal/admin-profile-modal.component';
import { customerTenant } from '@env/environment';
import { TenantService } from '@lib/services/tenant.service';
import { Store } from '@ngrx/store';
import { clearTenantKey } from '@store/actions/tenant.actions';
import { clearPermissions } from '@store/actions/permission.actions';
import { PermissionService } from '@lib/services/permission.service';
import { Permission } from '@lib/enums';

@Component({
    standalone: true,
    imports: [CommonModule, AngularMaterialModule],
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() drawer: any;

    @Output()
    open: EventEmitter<boolean> = new EventEmitter();
    permissions: string[];

    isOpen = false;
    primary_color = '';
    customerTenant = customerTenant;
    protected isRiyadTenant: boolean;
    constructor(private router: Router, 
        public settingService: SettingsService, 
        private dialog: MatDialog, 
        private tenantService: TenantService, 
        private permissionService: PermissionService,
        private store: Store) {
            const tenantKey = this.tenantService.getTenantKey() || '';
            this.isRiyadTenant = tenantKey.split('_')[0] === this.customerTenant.RIYAD;
        }

    ngOnInit() {
        this.permissions = this.permissionService.getPermissions();
        this.settingService.settingsDetails.subscribe((item) => {
          if(item?.primary_color) {
            this.primary_color = item?.primary_color;
          }
        });
    }

    isRouteMatch(route: string): boolean {
        if (this.router.url === route) return true;

        return false;
    }

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    logout(): void {
        const tenantKey = this.tenantService.getTenantKey() || '';
         // Clear all local storage data
          localStorage.clear();
      // (Optional) Clear session storage if needed
         sessionStorage.clear();
        this.store.dispatch( clearTenantKey() );
        this.store.dispatch( clearPermissions() );
        this.router.navigate([`/auth/${tenantKey}/login`]);
    }

    openNav() {
        this.open.emit(true);
    }

    get getTenantInfo(){
        const tenantKey = this.tenantService.getTenantKey() || '';
        return customerTenant.EDB == tenantKey;
    }

    get canChangePassword(){
        return this.permissions.includes(Permission.UserChangePassword);
    }

    openChangePassword(): void {
        this.dialog.open(ChangePasswordModalComponent, {
            width: '588px',
        });
    }

    viewAdminProfile(): void {
        this.dialog.open(AdminProfileModalComponent, {
            autoFocus: false,
            width: '660px',
        });
    }
}
